import * as cookie from "cookie";
import jwt from "jsonwebtoken";

import { redirectToLogin } from "utils/classroom";

export function decodeFlightAuthToken(flightAuthToken: string) {
  if (!flightAuthToken) {
    window.flightLogger.error("[App] Auth token not found");
    redirectToLogin();
    return;
  }

  // Decode the JWT
  //
  // NOTE: This is decoding without HMAC verification. Since this is client-side
  // code, we do not have access to the JWT shared secret here. We received this
  // JWT from the Picasso server, and must pass the full JWT along to any backend
  // service that will verify identity (e.g. the Flight WSS server).
  const flightAuth = jwt.decode(flightAuthToken);
  if (!flightAuth || typeof flightAuth !== "object") {
    window.flightLogger.error("[App] Failed to decode JWT");
    redirectToLogin();
    return;
  }
  const userId = `${flightAuth.userId}`;

  if (!userId) {
    window.flightLogger.error("[App] User ID not found in JWT");
    redirectToLogin();
    return;
  }

  const csrfToken = flightAuth.csrftoken as string;
  if (!csrfToken) {
    window.flightLogger.warn(`[App] CSRF token not found in Flight JWT for User ${userId}`);
  }

  document.cookie = cookie.serialize("csrftoken", csrfToken, {
    maxAge: 365 * 24 * 60 * 60,
    path: "/",
    sameSite: "lax",
    secure: true,
  });

  return userId;
}
